import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { VideosProvider as Provider, platformProviderValue } from '@shapeable/ui';

const VIDEOS_QUERY = graphql`
  query PlatformVideosQuery {
    platform {
      allVideos {
        openGraph { description { plain } image { thumbnails { card { url url2x } bubble { url url2x } } } }
        id name path url slug __typename updated created
        type { id name slug }
        description { text } 
        thumbnail { url }
        taxonomyLabel
        people {
          openGraph { image { url thumbnails { bubbleLarge { url url2x } } } }
          __typename id name slug
          _schema { label pluralLabel }
        }
        color { id name value }
        topics {
          openGraph { image { url } }
          _schema { label pluralLabel }
          __typename id name slug
        }
        challenges {
          openGraph { image { url } }
          _schema { label pluralLabel }
          __typename id name slug
        }
        keyIssues {
          openGraph { image { url } }
          _schema { label pluralLabel }
          __typename id name slug
        }
        trends {
          openGraph { image { url } }
          _schema { label pluralLabel }
          __typename id name slug
        }
        subTopics {
          openGraph { image { url } }
          _schema { label pluralLabel }
          __typename id name slug
        }

      }
    }
  }`;

export const VideosProvider: React.FC<any> = ({ children }) => {
  return <Provider value={ platformProviderValue( useStaticQuery(VIDEOS_QUERY), 'allVideos' ) }>{children}</Provider>;
};